import useFirebase from './useFirebase';
import firebaseConfig from '../lib/firebaseConfig';

export default () => useFirebase(firebaseConfig, 'track.me.st');